"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("../../../common/js/atoms/Icon"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const translation_1 = require("../../../common/js/helper/translation");
const NotificationStore_1 = __importDefault(require("../../stores/NotificationStore"));
const NotificationItem_1 = __importDefault(require("./NotificationItem"));
const NotificationModal = (props) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "modal-header znd-modal__header" },
            react_1.default.createElement("h3", { className: "znd-modal__title" }, (0, translation_1.t)('notifications.title')),
            react_1.default.createElement("div", { className: "znd-modal__close", onClick: props.onCancel },
                react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.close }))),
        react_1.default.createElement("div", { className: "modal-body znd-activate-license-modal__body" }, NotificationStore_1.default.notifications.map((notification, key) => {
            return react_1.default.createElement(NotificationItem_1.default, { key: key, item: notification });
        }))));
};
exports.default = NotificationModal;
